var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3309_3207)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0404 31.2243C23.9016 31.2243 16.5202 23.8136 16.5202 14.7041C16.5202 23.8136 9.10955 31.2243 0 31.2243C9.10955 31.2243 16.5202 38.6057 16.5202 47.7152C16.5202 38.6057 23.9016 31.2243 33.0404 31.2243Z",
    fill: "#F8579F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0005 39.7481C44.9918 39.7481 40.9496 35.6766 40.9496 30.6971C40.9496 35.6766 36.8781 39.7481 31.8986 39.7481C36.8781 39.7481 40.9496 43.7903 40.9496 48.7991C40.9496 43.7903 44.9918 39.7481 50.0005 39.7481ZM44.7867 12.2144C38.6942 12.2144 33.7732 7.29349 33.7732 1.20093C33.7732 7.29349 28.8523 12.2144 22.7598 12.2144C28.8523 12.2144 33.7732 17.1353 33.7732 23.2279C33.7732 17.1353 38.6942 12.2144 44.7867 12.2144Z",
    fill: "#FF385C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3309_3207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeStar);
export default __webpack_public_path__ + "static/media/home_star.0102aee62c3fe57c86afdb0483f9354a.svg";
export { ForwardRef as ReactComponent };